import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { signInWithPopup, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

function Login({ onClose, onLoginSuccess }) {
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);

  useEffect(() => {
    // 인앱 브라우저 감지
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isInstagram = ua.indexOf('Instagram') > -1;
    const isFacebook = ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
    const isTwitter = ua.indexOf('Twitter') > -1;
    const isLine = ua.indexOf('Line') > -1;
    const isKakao = ua.indexOf('KAKAOTALK') > -1 || ua.indexOf('KakaoTalk') > -1;

    setIsInAppBrowser(isInstagram || isFacebook || isTwitter || isLine || isKakao);
  }, []);

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      console.log('로그인 성공:', result.user);
      onClose();
      if (onLoginSuccess) onLoginSuccess();
    } catch (error) {
      console.error('구글 로그인 실패:', error);
      console.error('에러 코드:', error.code);
      console.error('에러 메시지:', error.message);

      if (error.code === 'auth/popup-closed-by-user') {
        // 사용자가 팝업을 닫은 경우 - 조용히 처리
        return;
      }
      if (error.code === 'auth/web-storage-unsupported' || error.code === 'auth/unauthorized-domain') {
        alert('⚠️ 인스타그램/인앱 브라우저에서는 로그인이 제한됩니다.\n\n📱 해결 방법:\n우측 상단 메뉴(⋯ 또는 ···)를 눌러\n"외부 브라우저에서 열기" 또는 "Safari/Chrome으로 열기"를 선택해주세요.');
      } else {
        alert(`로그인 실패\n\n에러 코드: ${error.code}\n에러 메시지: ${error.message}\n\n브라우저의 쿠키 설정을 확인해주세요.`);
      }
    }
  };

  const handleAppleLogin = async () => {
    try {
      const provider = new OAuthProvider('apple.com');
      const result = await signInWithPopup(auth, provider);
      console.log('로그인 성공:', result.user);
      onClose();
      if (onLoginSuccess) onLoginSuccess();
    } catch (error) {
      console.error('애플 로그인 실패:', error);
      console.error('에러 코드:', error.code);
      console.error('에러 메시지:', error.message);

      if (error.code === 'auth/popup-closed-by-user') {
        // 사용자가 팝업을 닫은 경우 - 조용히 처리
        return;
      }
      if (error.code === 'auth/web-storage-unsupported' || error.code === 'auth/unauthorized-domain') {
        alert('⚠️ 인스타그램/인앱 브라우저에서는 로그인이 제한됩니다.\n\n📱 해결 방법:\n우측 상단 메뉴(⋯ 또는 ···)를 눌러\n"외부 브라우저에서 열기" 또는 "Safari/Chrome으로 열기"를 선택해주세요.');
      } else {
        alert(`로그인 실패\n\n에러 코드: ${error.code}\n에러 메시지: ${error.message}\n\n브라우저의 쿠키 설정을 확인해주세요.`);
      }
    }
  };

  return (
    <div className="fade-in" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="slide-up" style={{
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#8B7355'
          }}
        >
          ×
        </button>

        <div style={{
          fontSize: '32px',
          marginBottom: '16px'
        }}>
          🍼
        </div>

        <h2 style={{
          color: '#E8A87C',
          marginBottom: '12px',
          fontSize: '24px'
        }}>
          bébé-note
        </h2>

        <p style={{
          color: '#8B7355',
          marginBottom: '16px',
          fontSize: '14px'
        }}>
          우리 아기의 소중한 성장 기록을 시작하세요
        </p>

        {isInAppBrowser && (
          <div style={{
            backgroundColor: '#FFF3CD',
            border: '1px solid #FFD700',
            borderRadius: '12px',
            padding: '12px',
            marginBottom: '24px',
            fontSize: '13px',
            color: '#856404',
            lineHeight: '1.5'
          }}>
            ⚠️ <strong>인스타그램/인앱 브라우저 감지</strong><br />
            로그인이 제한될 수 있습니다.<br />
            우측 상단 메뉴(⋯)에서<br />
            <strong>Safari 또는 Chrome으로 열기</strong>를 선택해주세요.
          </div>
        )}

        <button
          onClick={handleGoogleLogin}
          style={{
            backgroundColor: 'white',
            border: '2px solid #E8A87C',
            borderRadius: '12px',
            padding: '14px 24px',
            width: '100%',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#8B7355',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            transition: 'all 0.2s',
            marginBottom: '12px'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#FAF3E8'}
          onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
        >
          <svg width="20" height="20" viewBox="0 0 20 20">
            <path fill="#4285F4" d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z"/>
            <path fill="#34A853" d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z"/>
            <path fill="#FBBC05" d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z"/>
            <path fill="#EA4335" d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z"/>
          </svg>
          Google로 시작하기
        </button>

        <button
          onClick={handleAppleLogin}
          style={{
            backgroundColor: '#000000',
            border: 'none',
            borderRadius: '12px',
            padding: '14px 24px',
            width: '100%',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            transition: 'all 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#333333'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#000000'}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="white">
            <path d="M16.365 8.846c-.038-2.545 2.034-3.76 2.126-3.817-1.16-1.718-2.966-1.953-3.607-1.98-1.536-.158-2.998.92-3.777.92-.779 0-1.983-.897-3.26-.873-1.677.025-3.222 1-4.087 2.537-1.741 3.098-.445 7.686 1.251 10.198.828 1.23 1.817 2.612 3.115 2.563 1.275-.05 1.757-.838 3.298-.838 1.541 0 1.975.838 3.26.813 1.347-.025 2.205-1.242 3.033-2.472.958-1.425 1.352-2.805 1.376-2.876-.03-.013-2.64-1.033-2.674-4.097zm-2.447-7.35C14.827.453 15.63-.58 15.63-.58c-.01-.017-1.215.484-2.016 1.22-.802.735-1.51 1.942-1.386 3.098.013.016 1.473.12 2.69-1.242z"/>
          </svg>
          Apple로 시작하기
        </button>
      </div>
    </div>
  );
}

export default Login;
